import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PPRLinedirectives.templates.Remove Property In Storage Details',
        defaultMessage: 'Remove Property In Storage Details',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PPRLinedirectives.templates.Property In Storage Details',
        defaultMessage: 'Are you sure you want to remove this Property In Storage Details from the list?',
    },
    stoFacNamValue: {
        id: 'quoteandbind.PPLProLinedirectives.templates.PropertyInStorage.Storage Facility Name',
        defaultMessage: 'Storage Facility Name : '
    },
    stoFacLocValue: {
        id: 'quoteandbind.PPLProLinedirectives.templates.PropertyInStorage.Storage Facility Location',
        defaultMessage: 'Storage Facility Location : '
    }
});